import { _ } from "../../../core/polyglot/polyglot.js";
import { Node } from "prosemirror-model";
import InsertInputValueAction from "../actions/InsertInputValueAction.js";
import SuggestionAction from "../actions/SuggestionAction/SuggestionAction.js";

/**
 * Todo: Add JSDoc comment
 */
export default function getAccountExtraSpec({ getAllAccounts }) {
	if (!getAllAccounts) {
		return [];
	}

	const allAccounts = getAllAccounts();

	return [
		makeAccountDropdownBuilder({ allAccounts }),
		makeAccountSuggestionsBuilder({ suggestions: allAccounts }),
	];
}

function makeAccountDropdownBuilder({ allAccounts }) {
	return () =>
		new InsertInputValueAction({
			type: "account",
			label: _("Accounts"),
			order: 120,
			items: allAccounts,
			dataTestName: "insert-account",
		});
}

function makeAccountSuggestionsBuilder({ suggestions }) {
	return () =>
		new SuggestionAction({
			type: "account",
			triggerCharacter: "_",
			isSuggestionMatching: ({ text, suggestion }) => {
				const suggestionLabel = suggestion.toString().toLowerCase();
				return suggestionLabel.includes(text.toLowerCase());
			},
			suggestionToNode,
			suggestionToLabel: (item) => item.getName(),
			suggestions,
		});
}

function suggestionToNode({ type, item, schema }) {
	return Node.fromJSON(schema, {
		type: `inputValue_${type}`,
		attrs: {
			id: item.getNumber(),
		},
	});
}
